<template>
  <div class="sliderDisplay">

    <div class="sliderDisplay__carousel">

      <hooper pagination="yes">
        <slide
          class="sliderDisplay__item"
          v-for="(item, index) in sliderList"
          :key="index"
          :index="index">

          <div>
            <span
              class="sliderDisplay__icon"
              :class="{'sliderDisplay__icon--arrival': !!item.iconModifier}"
            >
              <component :is="item.icon" />
            </span>

            <p
              class="sliderDisplay__text"
              v-html="item.textTemplate">
            </p>
          </div>
        </slide>

        <hooper-pagination slot="hooper-addons" />
      </hooper>
    </div>
  </div>
</template>

<script>
import {
  Hooper,
  Slide,
  Pagination as HooperPagination,
} from 'hooper';

export default {
  name: 'SliderDisplay',
  components: {
    Hooper,
    Slide,
    HooperPagination,
  },
  data() {
    return {
      sliderList: [
        {
          icon: 'ClockSvg',
          textTemplate:
            `
              Adiante seu <br>
              atendimento e  <br>
              economize seu tempo. 
            `
        },
        {
          icon: 'NoteSvg',
          textTemplate:
            `
              Altere seus dados <br>
              pessoais e de convênio <br>
              com rapidez e facilidade.      
            `
        },
        {
          icon: 'ArrivalSvg',
          iconModifier: 'sliderDisplay__icon--arrival',
          textTemplate:
            `
              Confirme sua chegada <br>
              e seja atendido com <br>
              prioridade.      
            `
        }
      ]
    };
  },
};
</script>

<style lang="scss">
.sliderDisplay {
  &__carousel {
    border: none;
    margin-top: 40px;
  }

  &__item {
    & i {
      border: none;
      display: flex;
      width: 100%;
      height: 40px;
    }
  }

  &__icon {
    width: 72px;
    height: 72px;
    margin-bottom: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background-color: var(--color-slider-circle);

    & svg {
      max-width: 33px;
      max-height: 33px;

      * {
        fill: var(--color-slider);
      }
    }

    &--arrival {
      & svg {
        max-width: 42px;
        max-height: 42px;
      }
    }
  }

  &__text {
    display: flex;
    text-align: left;
    color: #161616;
    font-size: var(--font-size-4);
    line-height: 133%;
    font-weight: 600;

    @media (min-width: 321px) {
      font-size: var(--font-size-5);
    }
  }

  & .hooper{
    height: 240px;

    &-pagination {
      padding: 5px 0;
      left: 0;
      transform: initial;
    }

    &-indicator {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: var(--color-grey-5);
      transition: width ease-in-out 0.3s, border-radius ease-in-out 0.3s;
      margin: 0 4px;

      &.is-active {
        width: 24px;
        height: 8px;
        border-radius: 90px;
        background-color: var(--color-grey-7);
      }
    }
  }
}
</style>
